export function isSupportTab() {
  return ~window.location.href.indexOf('/support')
}
